import '../../assets/stylesheets/application.tailwind.css'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { router } from '../routes'
import { AuthProvider } from '../contexts/AuthContext'
import { ThemeProvider } from '../contexts/ThemeContext'
import ErrorBoundary from '../components/common/ErrorBoundary'

const container = document.getElementById('root')

if (!container) {
  throw new Error('Root container not found')
}

const root = ReactDOM.createRoot(container)

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>
) 